import { Injectable } from '@angular/core';
import { ApiResponse } from 'src/AngularJS/Models/api-response.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CoachingEffectivenessData } from './coaching-effectiveness.model';

@Injectable({
    providedIn: 'root'
})
export class CoachingEffectivenessService {

    constructor(
      private cvApiService: CVApiService
    ) { }

    public async loadData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false){
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/coachingEffectiveness/`
                + `${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<CoachingEffectivenessData>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting coaching effectiveness data");
            throw err;
        }
    }

    public async exportData(moduleKey: string, moduleID: number){
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/coachingEffectiveness/${moduleKey}/${moduleID}/export`;
            const response = await this.cvApiService.get(url, renderEndpoint);
            if (response.status_code !== 200)
                throw response;
            return response as ApiResponse<string>;
        } catch (e) {
            throw e;
        }
    }
}
